<template>
  <div class="page page-error">
    <div class="section">
      <h2 class="error-code">404</h2>
      <div class="error-message">Page not found.</div>
      <div class="action">
        <router-link :to="`/${teamName}`" class="btn btn-primary return-button">Return to Homepage</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    teamName() {
      return this.$route.params.teamName;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/themes/helper.scss';
@import '~@/assets/scss/variables.scss';

.return-button {
  color: white !important;
}

.page-error {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  .section {
    display: flex;
    flex-direction: column;
    align-items: center;

    .error-code {
      font-size: calc(24px + 10vw);
      color: $gray-600;
    }

    .error-message {
      font-size: calc(12px + 2vw);
      font-weight: 600;
      text-align: center;
      color: $gray-400;
    }

    .action {
      margin-top: $spacer * 3;
    }
  }
}
</style>
